/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useGlobalContext } from '../../../context/GlobalContext';
import { IContaCleanDTO, IDespesaFullDTO } from '../../../models/happy-code-api.model';
import { Predicate } from '../../../models/predicate.model';
import { PageableResponse } from '../../../models/response.model';
import { useContaService } from '../../../services/conta.service';
import { useDespesaService } from '../../../services/despesa.service';
import { FiltrosDespesas } from '../types/filters';
import buildFiltersPredicate from './use-filter-build';
import { useLogService } from '../../../services/log.service';

export default function useFetchData(fetchBignumbers?: (predicate: Predicate, unidadeId: number) => void) {
	const [despesas, setDespesas] = useState<PageableResponse<IDespesaFullDTO>>();
	const [loadingTable, setLoadingTable] = useState(false);
	const [page, setPage] = useState(1);
	const [dataInicioPersonalizada, setDataInicioPersonalizada] = useState<moment.Moment | null>(null);
	const [dataFimPersonalizada, setDataFimPersonalizada] = useState<moment.Moment | null>(null);
	const [contas, setContas] = useState<IContaCleanDTO[]>();
	const [filters, setFilters] = useState<FiltrosDespesas>({
		contaId: null,
		vencimento: null,
		dsDespesa: null,
	});
	const { unidade, setIsGlobalLoading } = useGlobalContext();

	const despesaService = useDespesaService();
	const contaService = useContaService();
	 const logService = useLogService();

	const findDespesas = useCallback(
		async (predicateFilters?: Predicate) => {
			const predicate = new Predicate();
			predicate.addOption('ativo', true);
			predicate.addOption('unidade.id', unidade.id);
			setIsGlobalLoading(true);
			fetchBignumbers?.(predicateFilters ? predicateFilters : predicate, unidade.id);
			await despesaService
				.findFullCustomTable(predicateFilters ? predicateFilters : predicate)
				.then((response) => {
					setDespesas(response.data);
				})
				.finally(() => {
					setIsGlobalLoading(false);
					setLoadingTable(false);
				});
		},
		[despesaService]
	);

	const fetchContas = useCallback(async () => {
		const predicate = new Predicate();
		predicate.addOption('ativo', true);
		predicate.addOption('unidade.id', unidade.id);
		await contaService.findCleanList(predicate).then((response) => {
			setContas(response.data);
		});
	}, [contaService]);

	const registraLog =  async () => {
		 logService.registraLog({
                descricaoEvento: 'Acesso contas a pagar',
                descricaoTipo: 'Acesso a tela',
                idTipo: null,
                id: null,
                descricaoUsuario: null,
                ativo: true,
            });
	}

	useEffect(() => {
		setIsGlobalLoading(true);
		// const viewed = getObject('@HappyCode/tourContasAPagar');

		// if (viewed === null || viewed === undefined) {
		// 	setObject('@HappyCode/tourContasAPagar', true);
		// }
		Promise.all([fetchContas(), findDespesas(), registraLog()]).finally(() => setIsGlobalLoading(false));
	}, []);

	const buildFiltersAndFetch = async (e?: React.FormEvent, pageEvent?: number) => {
		if (e) e.preventDefault();
		const predicate = buildFiltersPredicate(filters, unidade?.id, dataInicioPersonalizada? dataInicioPersonalizada.toDate() : null, dataFimPersonalizada? dataFimPersonalizada.toDate() : null);
		if (typeof pageEvent === 'number') {
			setPage(pageEvent + 1);
			predicate.page = pageEvent;
		} else {
			setPage(1);
			predicate.page = 0;
		}
		await findDespesas(predicate);
	};

	const cleanFilters = () => {
		setFilters({
			contaId: null,
			vencimento: null,
			dsDespesa: null,
		});
		findDespesas();
	};

	return {
		despesas,
		loadingTable,
		filters,
		page,
		contas,
		dataInicioPersonalizada,
		dataFimPersonalizada,
		setFilters,
		buildFiltersAndFetch,
		cleanFilters,
		setDataInicioPersonalizada,
		setDataFimPersonalizada,
	};
}
